import { createFileRoute } from "@tanstack/react-router";
import { ConfigurationPlayground } from "@/pages/3d/configuration/ConfigurationPlayground";

export const Route = createFileRoute("/demo/3d/configuration/playground")({
  component: ConfigurationPlayground,
});
